function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11",
  transform: "translate(61.476 8.719)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M358.465,282.548c0,3.338-1.774,4.732-4.394,4.732s-4.352-1.437-4.352-4.732v-9.3h11.492v-3.676H349.719v-7.141H345.7v20.112c0,5.662,3.38,8.45,8.366,8.45s8.365-2.788,8.365-8.45v-.465h-3.971Z",
  transform: "translate(-345.705 -262.436)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M402.992,278.683c-6.592,0-11.239,4.648-11.239,10.985s4.648,10.985,11.239,10.985,11.239-4.648,11.239-10.985S409.584,278.683,402.992,278.683Zm0,18.253a7.268,7.268,0,1,1,7.183-7.267A6.9,6.9,0,0,1,402.992,296.936Z",
  transform: "translate(-373.072 -272.092)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M461.621,278.7c-.216-.011-.433-.017-.655-.017-5.366,0-9,2.957-9,9.126V300.1h4.014V287.809c0-3.845,1.986-5.408,4.985-5.408.225,0,.442.012.655.03Z",
  transform: "translate(-408.857 -272.092)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M486.492,278.683c-.353,0-.7.016-1.041.042a11.64,11.64,0,0,0-5.016,1.521,10.256,10.256,0,0,0-3.038,2.7,10.675,10.675,0,0,0-1.938,4.462,12.231,12.231,0,0,0-.207,2.259,13.278,13.278,0,0,0,.207,2.361,10.251,10.251,0,0,0,9.991,8.616c.121,0,.243.008.365.008a8.394,8.394,0,0,0,8.07-4.9h.084V300.1h3.676V289.838C497.647,283.162,493.083,278.683,486.492,278.683Zm0,18.253a8.6,8.6,0,0,1-1.041-.069,6.853,6.853,0,0,1-6.142-7.2,8.194,8.194,0,0,1,.443-2.695,6.575,6.575,0,0,1,3.135-3.721,7.3,7.3,0,0,1,2.564-.782,8.517,8.517,0,0,1,1.041-.07,7.268,7.268,0,0,1,0,14.534Z",
  transform: "translate(-422.696 -272.092)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M546.383,278.683c-6.169,0-10.309,3.591-10.309,10.563V300.1h4.014V289.246c0-4.521,2.492-6.845,6.3-6.845s6.3,2.324,6.3,6.845V300.1h4.014V289.246C556.692,282.232,552.552,278.683,546.383,278.683Z",
  transform: "translate(-458.842 -272.092)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M603.758,278.683c-6.592,0-11.239,4.648-11.239,10.985,0,7.1,5.155,10.985,10.563,10.985a8.394,8.394,0,0,0,8.07-4.9h.084V300.1h3.676V289.838C614.912,283.162,610.349,278.683,603.758,278.683Zm0,18.253a7.268,7.268,0,1,1,7.182-7.267A6.9,6.9,0,0,1,603.758,296.936Z",
  transform: "translate(-492.388 -272.092)",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M217.173,240.945a23.023,23.023,0,0,0-7.687,44.717l.019.006q.934.33,1.9.583V265.836h-1.922V283.6a21.078,21.078,0,1,1,15.375,0V265.836h-1.922v20.416q.969-.251,1.9-.583l.019-.006a23.023,23.023,0,0,0-7.687-44.717Z",
  transform: "translate(-194.173 -240.945)",
  fill: "#50b4e2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M221.59,290.171H211.77a1.983,1.983,0,0,0-2.913-.562.973.973,0,0,0-.273.272,1.965,1.965,0,0,0,1.522,3.176,1.921,1.921,0,0,0,1.664-.963h9.821a.792.792,0,0,1,.706.856v22.491q.949.133,1.922.187V292.95A2.709,2.709,0,0,0,221.59,290.171Z",
  transform: "translate(-202.499 -269.628)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M268.155,293.058a1.965,1.965,0,0,0,1.522-3.175.978.978,0,0,0-.272-.272,1.983,1.983,0,0,0-2.914.561h-9.84a2.709,2.709,0,0,0-2.627,2.779v22.678q.972-.053,1.922-.187V292.95a.792.792,0,0,1,.705-.856h9.84A1.92,1.92,0,0,0,268.155,293.058Z",
  transform: "translate(-229.743 -269.628)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_15",
  "data-name": "Rectangle 15",
  width: 15.375,
  height: 1.922,
  transform: "translate(15.313 11.791)",
  fill: "#50b4e2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  width: 26.959,
  height: 1.922,
  transform: "translate(9.53 16.178)",
  fill: "#50b4e2"
}));

var SvgToranaLogo = function SvgToranaLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Torana_Logo",
    "data-name": "Torana Logo",
    width: 184,
    height: 46,
    viewBox: "0 0 184 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToranaLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/torana-logo.7c5d9fa0.svg";
export { ForwardRef as ReactComponent };